import { GEMINI_VOCAL_CUES } from '../../supabase/functions/_shared/gemini-directions';
import type { TedIntonationSpan } from '@/types/screenplay';
export const POINT_VOCAL_CUES = GEMINI_VOCAL_CUES.filter(cue => cue !== 'short pause' && cue !== 'long pause');
export const markerLabel = (cue: string) => cue.replace(/^./u, c => c.toUpperCase());
export const isInlineMarker = (span?: TedIntonationSpan) => !!(span?.gemini?.pauseMarker || span?.gemini?.cueMarker);
/** Only our allowlisted markers are structural. Other braces remain screenplay text. */
export function inlineMarkers(text: string) {
  return [...text.matchAll(/\{([^{}]+)\}|\[Pause\]/giu)].flatMap(match => {
    const cue = (match[1] ?? 'pause').toLowerCase();
    if (cue !== 'pause' && !(POINT_VOCAL_CUES as readonly string[]).includes(cue)) return [];
    return [{ start: match.index!, end: match.index! + match[0].length, cue }];
  });
}
